import React from 'react';

function LocationIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <g>
        <path
          fill="#333"
          d="M9.5 7a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM14 7c0 2.874-3.097 6.016-4.841 7.558a1.74 1.74 0 01-2.318 0C5.097 13.016 2 9.874 2 7a6 6 0 1112 0zm-1 0A5 5 0 003 7c0 1.108.615 2.395 1.57 3.683.934 1.258 2.087 2.377 2.933 3.126a.74.74 0 00.994 0c.846-.749 2-1.867 2.933-3.126C12.385 9.395 13 8.108 13 7z"
        ></path>
      </g>
    </svg>
  );
}

export default LocationIcon;
